export const compare = (
  a: string = '',
  b: string = '',
  isAsc: boolean
): number => (a < b ? -1 : 1) * (isAsc ? 1 : -1);

export const compareDates = (
  a: Date = new Date(),
  b: Date = new Date(),
  isAsc: boolean
): number => (a < b ? -1 : 1) * (isAsc ? 1 : -1);
